<template>
    <div class="button-group" :class="{ responsive }">
        <slot>
            <ButtonToggleOption
                v-for="(option, i) in options"
                :key="i"
                :selected="isSelected(option)"
                :block="block"
                :data-qa="option.value"
                @click="updateValue(option)"
            >
                {{ option.label }}
            </ButtonToggleOption>
        </slot>
    </div>
</template>

<script>
import ButtonToggleOption from './ButtonToggleOption';

export default {
    name: 'DsButtonToggle',

    components: { ButtonToggleOption },

    props: {
        /**
         * Allow the button toggle to expand to fit its container
         */
        block: Boolean,

        /**
         * Array of value/label options
         */
        options: {
            type: Array,
            default: () => [],
        },

        /**
         * Allow multiple selections in array format
         */
        multiple: Boolean,

        /**
         * (DEPRECATED) Prevent deselect on a single button toggle similar to how radio functions
         */
        preventSingleDeselect: Boolean,

        /**
         * Stack buttons on mobile screens because you have lots of buttons in the toggle
         */
        responsive: Boolean,

        /**
         * Array of selected values
         */
        value: [String, Number, Array],
    },

    methods: {
        isSelected({ value }) {
            if (!this.multiple) {
                return this.value === value;
            }

            return this.value.includes(value);
        },

        updateValue({ value }) {
            if (!this.multiple) {
                if (this.preventSingleDeselect && this.value === value) {
                    return null;
                }

                return this.$emit('input', this.value === value ? null : value);
            }

            const options = [...this.value];
            const index = options.indexOf(value);

            if (index !== -1) {
                options.splice(index, 1);
            } else {
                options.push(value);
            }

            return this.$emit('input', options);
        },
    },
};
</script>
